import React, { Dispatch, SetStateAction } from 'react';
import { Button, makeStyles, createStyles, Theme, Box, useTheme } from '@material-ui/core';
import { EventMapDiagram } from '../../../../map-editor/src';
import { FullScreen } from '../../../../components/FullScreen';
import { useFormDialog } from '@terragotech/gen5-shared-components';
import { MapperShortCutInfoDialog } from '../../../../components/FormDialog/MapperShortCutInfoDialog';
import { EventMapDiagramModel } from 'map-editor/src/EventMapDiagramModel';
import { DiagramEngine } from '@projectstorm/react-diagrams';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKeyboard } from '@fortawesome/pro-light-svg-icons';
import { useBlocker, useOutletContext } from 'react-router-dom';
import useRouteBlocker from 'common/useBlocker';
import { NodeMapDefinition } from '@terragotech/gen5-datamapping-lib';

interface eventMapProps {
  model?: EventMapDiagramModel;
  engine: DiagramEngine;
  checkModelHasChanged: () => boolean;
  hasSetPosition: boolean;
  onDiscard: () => void;
  setInitialDataMap: Dispatch<SetStateAction<NodeMapDefinition | undefined>>;
}
interface props {
  eventMapProps: eventMapProps;
  onSave: () => void;
}
export const EventMapper: React.FC = () => {
  const { eventMapProps, onSave } = useOutletContext() as props;
  const classes = useStyles();
  const theme = useTheme();
  const formDialog = useFormDialog();
  const handleShortCutInfo = () => {
    formDialog<typeof MapperShortCutInfoDialog>((props) => <MapperShortCutInfoDialog {...props} />);
  };
  const { model, engine, checkModelHasChanged, hasSetPosition, onDiscard, setInitialDataMap } =
    eventMapProps;

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      currentLocation.pathname !== nextLocation.pathname && checkModelHasChanged()
  );

  useRouteBlocker({ blocker, onSave, onDiscard });

  return (
    <Box className={classes.tabContainer}>
      <Box className={classes.eventMapperContainer}>
        <FullScreen>
          <EventMapDiagram
            model={model}
            engine={engine}
            hasSetPosition={hasSetPosition}
            mapScenario={'FUNCTION_MAPPING'}
            setInitialDataMap={setInitialDataMap}
          />
          <Button
            style={{
              position: 'absolute',
              right: 13,
              top: 16,
              color: theme.palette.text.secondary,
              backgroundColor: theme.palette.background.paper,
              zIndex: 10,
              fontWeight: 500,
              fontSize: 16,
            }}
            onClick={handleShortCutInfo}
            variant="contained"
            startIcon={<FontAwesomeIcon icon={faKeyboard} />}
          >
            Shortcuts
          </Button>
        </FullScreen>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabContainer: {
      height: 'auto',
      paddingBottom: 10,
    },
    eventMapperContainer: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflowX: 'auto',
      height: '100vh',
      border: `1px solid ${theme.palette.divider}`,
    },
  })
);
